import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import Layout from '@/container/Layout';
import { HotlineClientCreateCompleteView } from '@/feature/hotline/client/create/complete/page/HotlineClientCreateCompleteView';
import { useHotlineClientCreateFormContext } from '@/feature/hotline/client/create/context/HotlineClientCreateFormContext';
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { useParams } from '@/hooks/lib/react-router/useParams';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名ホットライン編集完了（ロジック部分のみ）
 */
export const HotlineClientEditCompletePage = () => {
    const { id = '' } = useParams();
    const { setFormValues } = useHotlineClientCreateFormContext();
    useEffect(() => {
        // フォームの状態をリセット
        setFormValues(null);
    }, [setFormValues]);
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { relativePath: pagePath.hotline.client.editComplete(id), title: '匿名コンサルホットライン 再募集 - 完了 | PROFFIT' }), _jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineClientCreateCompleteView, {}) }))] }));
};
